import {
  AfterViewInit, ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  Input, OnChanges, OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {Item} from "../../models/Item";
import {timer} from "rxjs";

@Component({
  selector: 'app-item-location',
  templateUrl: './item-location.component.html',
  styleUrls: ['./item-location.component.scss']
})
export class ItemLocationComponent implements OnChanges, AfterViewInit, OnDestroy {

  @ViewChild('placeholder', {read: ViewContainerRef, static: false})
  private viewRef: ViewContainerRef;
  private currentComponentRef;
  @Input() item: Item;
  @Input() locationName;

  constructor(private cfr: ComponentFactoryResolver, private cd: ChangeDetectorRef) { }

  loadComponent() {
    this.viewRef.clear();
    Item.plugins.forEach((plugin)=>{
      if (!this.locationName){
        throw new Error('add locationName attribute to Location Component');
      }
      let componentClass = plugin.getComponentForLocation(this.locationName, this.item);
      if (componentClass){
        const componentFactory = this.cfr.resolveComponentFactory(componentClass);
        const componentRef = this.viewRef.createComponent(componentFactory);
        this.currentComponentRef = componentRef;
        componentRef.instance['item'] = this.item;
        if (!this.cd['destroyed']){
          this.cd.detectChanges();
        }
      }
    });
    if (!this.cd['destroyed']) {
      this.cd.detectChanges();
    }
    timer(500).subscribe(()=>{
      if (!this.cd['destroyed']){
        this.cd.detectChanges();
      }
    })
  }

  ngOnChanges(): void {
    if (this.viewRef){
      this.loadComponent();
        if (!this.cd['destroyed']){
          this.cd.detectChanges();
        }
    }
  }

  ngAfterViewInit(): void {
    this.loadComponent();
  }

  public reloadComponent(){
      this.loadComponent();
        if (!this.cd['destroyed']){
          this.cd.detectChanges();
        }
  }

  ngOnDestroy(): void {
    this.cd.detach();
  }

}
